// extracted by mini-css-extract-plugin
export default {"root":"root--389b615","heading":"heading--37c3dda","diets":"diets--260a698","specificity":"specificity--5f1da77","icon":"icon--8b42cac"};